import ActionButton from '../components/ActionButton/index';
import SectionTitle from '../components/PageTitle';
import React from 'react';
import {Banner, GridLayout} from './styles';
import {ContentContainer} from '../Landing/styles';
import {assetUrl} from '../Landing';


const CareerBanners = () => (
	<ContentContainer narrowedWidth>
		<SectionTitle light={false} id="hieu-minh-yeu-nghe">Hiểu mình yêu nghề</SectionTitle>
		<GridLayout>
			<Banner style={{backgroundImage: `url(${assetUrl('career_banner_1.jpg')})`}}>
				<div className="content">
					<div className="title">
						Lộ trình<br/> đa ngành
					</div>
					<div className="description">
						Bản đồ chi tiết cho sự nghiệp tiến nhanh dành cho Newbie
					</div>
					<ActionButton href="https://www.vietnamworks.com/lo-trinh-su-nghiep" target="_blank" variant="orange">Tra cứu ngay</ActionButton>
				</div>
			</Banner>
			<Banner style={{backgroundImage: `url(${assetUrl('career_banner_2.jpg')})`}}>
				<div className="content">
					<div className="title">
						Yêu người hợp mệnh
						Tìm nghề hợp số
					</div>
					<div className="description">
						Tìm nghề hợp số cùng công cụ tra cứu<br/>
						Nhân số học
					</div>
					<ActionButton href="https://www.vietnamworks.com/nhan-so-hoc" target="_blank" variant="orange">Tra cứu ngay</ActionButton>
				</div>
			</Banner>
		</GridLayout>
	</ContentContainer>
)

export default CareerBanners
